import React from "react";
import { createHashRouter } from "react-router-dom";

import SmartBeansSearch from "../pages/smartBeans/smartBeansSearch/index";
import SmartBeansInput from "../pages/smartBeans/smartBeansInput";
import InputStatusSearch from "../pages/smartBeans/inputStatusSearch";
import SmartBeansAudit from "../pages/smartBeans/smartBeansAudit";
import UserSearch from "../pages/userManager/userSearch/index";
import UserAdd from "../pages/userManager/userAdd";
import ModuleRole from "../pages/moduleRoleManager/moduleRole";
import ModuleRoleAdd from "../pages/moduleRoleManager/moduleRoleAdd";
import ModuleDepartAdd from "../pages/moduleRoleManager/moduleRole/addDepart";
import StudentInfoAdd from "../pages/studentInfo/studentInfoAdd";
import StudentInfoSearch from "../pages/studentInfo/studentInfoSearch";
import { App } from "../App";

import Login from "../pages/login";

import { routerPath } from "./config";

export const router = createHashRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: routerPath.smartBeansSearch,
        element: <SmartBeansSearch />,
      },
      {
        path: routerPath.smartBeansInput,
        element: <SmartBeansInput />,
      },
      {
        path: routerPath.inpurtStatusSearch,
        element: <InputStatusSearch />,
      },
      {
        path: routerPath.smartBeansAudit,
        element: <SmartBeansAudit />,
      },
      {
        path: routerPath.userSearch,
        element: <UserSearch />,
      },
      {
        path: routerPath.userAdd,
        element: <UserAdd />,
      },
      {
        path: routerPath.moduleRole,
        element: <ModuleRole />,
      },
      {
        path: routerPath.moduleRoleAdd,
        element: <ModuleRoleAdd />,
      },
      {
        path: routerPath.departAdd,
        element: <ModuleDepartAdd />,
      },
      {
        path: routerPath.studentInfoAdd,
        element: <StudentInfoAdd />,
      },
      {
        path: routerPath.studentInfoSearch,
        element: <StudentInfoSearch />,
      },
    ],
  },
  {
    path: routerPath.login,
    element: <Login />,
  },
]);
